import { toast } from '~/legacy/utils/notifications'

export default {
  getProject: {
    url: '/surveys/:id/',
    options: {
      method: 'GET',
    },
  },
  getSurveys: {
    url: '/surveys/',
    options: {
      method: 'GET',
    },
  },
  getSurveysAdmin: {
    url: '/surveys/list_admin/',
    options: {
      method: 'GET',
    },
  },
  updateProject: {
    url: '/surveys/:id/',
    options: {
      method: 'PATCH',
    },
  },
  trashProject: {
    url: '/surveys/:id/trash/',
    options: {
      method: 'POST',
    },
  },
  trashSurveys: {
    url: '/surveys/trash_surveys/',
    options: {
      method: 'POST',
    },
  },
  remove_survey_listings: {
    url: '/surveys/:id/remove_survey_listings/',
    options: {
      method: 'POST',
    },
    onSuccess: [
      () =>
        toast('Spaces successfully removed from survey!', {
          appearance: 'success',
        }),
    ],
  },
  remove_survey_building: {
    url: '/surveys/:id/remove_survey_building/',
    options: {
      method: 'POST',
    },
    onSuccess: [
      () =>
        toast('Building successfully removed from survey!', {
          appearance: 'success',
        }),
    ],
  },
  getSurveyBuildings: {
    url: '/surveys/:id/survey_buildings/',
    options: {
      method: 'GET',
    },
  },
}
